/* Landing Page Builder - helper DOM (parser inert, runtime sandbox, bahagian & tema). Kod dijana tidak pernah dijalankan dalam dokumen aplikasi. */

const RUNTIME = `(function(){
var edit=false,pending={};
function send(m){m.__lp=1;try{parent.postMessage(m,"*")}catch(e){}}
var TEXT="h1,h2,h3,h4,h5,h6,p,span,a,button,li,label,small,strong,em,b,blockquote,figcaption,td,th,dt,dd";
function setEdit(on){edit=on;document.documentElement.classList.toggle("lp-editing",on);
document.querySelectorAll(TEXT).forEach(function(el){if(!el.hasAttribute("data-lp-id"))return;
if(!on){el.removeAttribute("contenteditable");return}
if(el.parentElement&&el.parentElement.closest("[contenteditable]"))return;
var ok=el.textContent.trim()&&Array.prototype.every.call(el.children,function(c){return /^(BR|B|STRONG|EM|I|SPAN|SMALL|U|MARK)$/.test(c.tagName)});
if(ok)el.setAttribute("contenteditable","true")})}
document.addEventListener("click",function(e){var t=e.target;var a=t.closest&&t.closest("a[href]");
if(edit){if(t.tagName==="IMG"){e.preventDefault();send({type:"img",id:t.getAttribute("data-lp-id"),src:t.getAttribute("src"),prompt:t.getAttribute("data-lp-image-prompt")||t.getAttribute("alt")||""});return}
var s=t.closest&&t.closest("[data-lp-section]");if(s)send({type:"section",id:s.getAttribute("data-lp-section")});if(a||t.closest("button"))e.preventDefault();return}
if(!a)return;var h=a.getAttribute("href")||"";
if(h.charAt(0)==="#"){var el=h.length>1&&document.getElementById(h.slice(1));if(el){e.preventDefault();el.scrollIntoView({behavior:"smooth"})}return}
e.preventDefault();send({type:"open",href:a.href})},true);
document.addEventListener("submit",function(e){var f=e.target;e.preventDefault();if(edit)return;
var d={};new FormData(f).forEach(function(v,k){if(typeof v!=="string")return;d[k]=d[k]?d[k]+", "+v:v});
var b=f.querySelector("[type=submit]");if(b)b.disabled=true;var rid=Math.random().toString(36).slice(2);pending[rid]={f:f,b:b};
send({type:"submit",rid:rid,form:f.getAttribute("data-lp-form")||"borang",data:d})},true);
document.addEventListener("input",function(e){var el=e.target.closest&&e.target.closest("[contenteditable][data-lp-id]");if(el)send({type:"text",id:el.getAttribute("data-lp-id"),html:el.innerHTML})},true);
window.addEventListener("message",function(e){var m=e.data||{};if(!m.__lp)return;
if(m.type==="submit-result"){var p=pending[m.rid];if(!p)return;delete pending[m.rid];if(p.b)p.b.disabled=false;
if(m.ok){p.f.reset();var s=p.f.querySelector("[data-lp-form-success]");if(s){s.hidden=false;s.style.display="";s.scrollIntoView({block:"center"})}else alert(m.message||"Terima kasih!")}else alert(m.message||"Gagal menghantar")}
if(m.type==="edit")setEdit(!!m.on);
if(m.type==="scroll"){var x=document.querySelector('[data-lp-section="'+m.id+'"]');if(x)x.scrollIntoView({behavior:"smooth",block:"start"})}
if(m.type==="img-set"){var i=document.querySelector('[data-lp-id="'+m.id+'"]');if(i)i.setAttribute("src",m.src)}
if(m.type==="theme"){var st=document.getElementById("lp-theme");if(st)st.textContent=m.css}});
var st=document.createElement("style");st.textContent=".lp-editing [contenteditable]{outline:1px dashed rgba(236,72,153,.55);outline-offset:2px;cursor:text}.lp-editing [contenteditable]:focus{outline:2px solid #ec4899;background:rgba(236,72,153,.04)}.lp-editing img{cursor:pointer;outline:2px dashed rgba(59,130,246,.7);outline-offset:-2px}.lp-editing [data-lp-section]:hover{box-shadow:inset 0 0 0 2px rgba(236,72,153,.35)}";
document.head.appendChild(st);
try{var R=/(^|[\\s_-])(fade|reveal|aos|animate-on-scroll|appear|scroll-anim|slide-up|reveal-up)/i,io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add("in","show","visible","active","is-visible","revealed","aos-animate");io.unobserve(x.target)}})},{threshold:0.05});
document.querySelectorAll("[class]").forEach(function(el){if(R.test(el.className&&el.className.baseVal===undefined?el.className:""))io.observe(el)})}catch(e){}
send({type:"ready"})})();`;

export const SANDBOX = "allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox";

export function parse(html) {
  return new DOMParser().parseFromString(html || "<!DOCTYPE html><html><head></head><body></body></html>", "text/html");
}

/** Beri data-lp-id pada setiap elemen body (untuk suntingan visual). */
export function tag(doc) {
  let n = 0;
  doc.body.querySelectorAll("*").forEach((el) => el.setAttribute("data-lp-id", `e${n++}`));
  return doc;
}

export function serialize(doc) {
  const c = doc.documentElement.cloneNode(true);
  c.querySelectorAll("[data-lp-id]").forEach((el) => el.removeAttribute("data-lp-id"));
  c.querySelectorAll("[contenteditable]").forEach((el) => el.removeAttribute("contenteditable"));
  return "<!DOCTYPE html>\n" + c.outerHTML;
}

/** HTML untuk srcdoc iframe = dokumen bertanda + runtime. */
export function srcdoc(doc) {
  const c = doc.documentElement.cloneNode(true);
  const s = doc.createElement("script");
  s.textContent = RUNTIME;
  (c.querySelector("body") || c).appendChild(s);
  return "<!DOCTYPE html>\n" + c.outerHTML;
}

export function publicSrcdoc(html) {
  return srcdoc(parse(html));
}

export function sections(doc) {
  return [...doc.querySelectorAll("[data-lp-section]")]
    .filter((el) => !el.parentElement.closest("[data-lp-section]"))
    .map((el) => ({ id: el.getAttribute("data-lp-section"), label: el.getAttribute("data-lp-label") || el.getAttribute("data-lp-section"),
      tag: el.tagName.toLowerCase(), hidden: el.hasAttribute("hidden"), el }));
}

export function uniqueSectionId(doc, base) {
  let i = 2;
  while (doc.querySelector(`[data-lp-section="${base}-${i}"]`)) i++;
  return `${base}-${i}`;
}

/** Ganti elemen bahagian dengan HTML baharu (dihurai secara inert). */
export function replaceSection(doc, id, html) {
  const el = doc.querySelector(`[data-lp-section="${id}"]`);
  if (!el) return false;
  const tmp = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const fresh = tmp.body.querySelector("[data-lp-section]") || tmp.body.firstElementChild;
  if (!fresh) return false;
  el.replaceWith(doc.importNode(fresh, true));
  return true;
}

export const THEME_KEYS = [
  ["--lp-primary", "Utama"], ["--lp-secondary", "Kedua"], ["--lp-accent", "Aksen"],
  ["--lp-bg", "Latar"], ["--lp-surface", "Permukaan"], ["--lp-text", "Teks"],
];

export function readTheme(doc) {
  const css = doc.getElementById("lp-theme")?.textContent || "";
  const out = {};
  for (const m of css.matchAll(/(--lp-[a-z-]+)\s*:\s*([^;}]+)/g)) out[m[1]] = m[2].trim();
  return out;
}

export function themeCss(theme) {
  return ":root{" + Object.entries(theme).map(([k, v]) => `${k}:${v}`).join(";") + "}";
}

export function writeTheme(doc, theme, fonts = []) {
  let st = doc.getElementById("lp-theme");
  if (!st) { st = doc.createElement("style"); st.id = "lp-theme"; doc.head.appendChild(st); }
  st.textContent = themeCss(theme);
  fonts.filter(Boolean).forEach((f) => {
    const fam = f.replace(/ /g, "+");
    if (![...doc.querySelectorAll('link[href*="fonts.googleapis.com"]')].some((l) => l.href.includes(`family=${fam}`))) {
      const l = doc.createElement("link");
      l.rel = "stylesheet";
      l.href = `https://fonts.googleapis.com/css2?family=${fam}:wght@400;600;700;800&display=swap`;
      doc.head.appendChild(l);
    }
  });
}

export const SAFE_OPEN = /^(https?:|mailto:|tel:|whatsapp:)/i;

/** Segmen pertama laluan aplikasi (AppRoutes.js) - selain ini, /{slug} mungkin landing page awam. */
const APP_SEGMENTS = new Set(("login reset-password pakej survey-2027 laporan-penggal status-pemasangan tiket-isu setup-password children activities nutrition " +
  "daily-logs development nutritional-status classes manage-teachers teacher-profile admin-profile album album-manage audit-logs pending-approval " +
  "kelulusan-kanak-kanak kelulusan-pengguna class-transition panduan-ibu-bapa manage-parents profile-settings settings reports attendance billing " +
  "child-registration pendaftaran-kanak-kanak takwim tetapan-guru panduan panduan-admin superadmin mimi").split(" "));

export function isLandingPath(pathname) {
  const m = /^\/([a-z0-9-]+)\/?$/.exec(pathname || "");
  return !!m && !APP_SEGMENTS.has(m[1]) && !/^kids\d{4}$/.test(m[1]);
}
